import React, { useEffect, useState } from 'react';
import './HowToUse.css';

const HowToUse = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [activeSection, setActiveSection] = useState('');

    const sections = [
        {
            id: 'system-overview',
            title: '🌐 System Overview',
            searchText: 'system overview solar panel erp installation maintenance projects sites employees teams payroll customers vendors contracts inventory procurement stock financial operations assets machinery access urls production development',
            content: (
                <>
                    <h3>System Overview</h3>
                    <h4>What is this system?</h4>
                    <p>This ERP system is designed for solar panel installation and maintenance companies to manage:</p>
                    <ul>
                        <li>Projects and Sites (New installations & O&M contracts)</li>
                        <li>Employees, Teams, and Payroll</li>
                        <li>Customers, Vendors, and Contracts</li>
                        <li>Inventory, Procurement, and Stock Management</li>
                        <li>Financial Operations (Invoices, Payments, Ledgers)</li>
                        <li>Assets and Machinery</li>
                    </ul>

                    {/* <h4 className="mt-4">Access URLs</h4>
                    <p>
                        <strong>Production:</strong> <a href="https://portal.shreenaths.com/" target="_blank" rel="noopener noreferrer">https://portal.shreenaths.com/</a><br />
                        <strong>Development:</strong> <a href="https://dev.shreenaths.com/" target="_blank" rel="noopener noreferrer">https://dev.shreenaths.com/</a>
                    </p> */}
                </>
            )
        },
        {
            id: 'user-roles',
            title: '👥 User Roles',
            searchText: 'user roles hierarchy admin ceo director sr hr hod scm supply chain accounts finance solar wind gss tl technical operations zonal head plant head site engineer technician helper',
            content: (
                <>
                    <h3>User Roles & Hierarchy</h3>
                    <h4 className="mt-3">Role Structure</h4>
                    <ul className="list-group list-group-flush">
                        <li className="list-group-item"><strong>Admin/CEO</strong> - Full system access, creates Director users</li>
                        <li className="list-group-item"><strong>Director</strong> - Creates Sr. HR, manages companies and customers</li>
                        <li className="list-group-item"><strong>Sr. HR</strong> - Creates department users (SCM, Accounts, HRM)</li>
                        <li className="list-group-item"><strong>HOD - SCM</strong> - Supply Chain Management Head</li>
                        <li className="list-group-item"><strong>HOD - Accounts</strong> - Finance and Accounting Head</li>
                        <li className="list-group-item"><strong>HOD - HRM</strong> - Human Resource Management Head</li>
                        <li className="list-group-item"><strong>HOD - Solar/Wind/GSS/TL</strong> - Technical Operations Head</li>
                        <li className="list-group-item"><strong>Zonal Head</strong> - Manages multiple sites in a zone</li>
                        <li className="list-group-item"><strong>Plant Head</strong> - Manages site operations</li>
                        <li className="list-group-item"><strong>Site Engineer</strong> - On-site technical management</li>
                        <li className="list-group-item"><strong>Site Technician</strong> - Field operations</li>
                        <li className="list-group-item"><strong>Helper</strong> - Support staff</li>
                    </ul>
                </>
            )
        },
        {
            id: 'admin-panel',
            title: '🛠️ Admin Panel',
            searchText: 'admin panel employee onboarding salary configuration attendance leave generate payroll companies customers mapping',
            content: (
                <>
                    <h3>1. ADMIN PANEL</h3>
                    <h4>What Admin Can Do</h4>
                    <p>The Admin is the system owner with complete control over the ERP.</p>

                    <h4 className="mt-4">Key Responsibilities</h4>

                    <h5 className="mt-3">A. Employee Onboarding</h5>
                    <p><strong>Purpose:</strong> Add new employees to the system</p>
                    <p><strong>Steps:</strong></p>
                    <ol>
                        <li>Login to Admin Panel</li>
                        <li>Navigate to <strong>Employee Management</strong> → <strong>Add New Employee</strong></li>
                        <li>Fill in employee details:
                            <ul>
                                <li>Personal Information (Name, DOB, Address, Contact)</li>
                                <li>Professional Details (Department, Designation, Joining Date)</li>
                                <li>Bank Details</li>
                                <li>Nominee Details</li>
                                <li>Previous Work Experience</li>
                                <li>Emergency Contact</li>
                            </ul>
                        </li>
                        <li>Click <strong>Save</strong> or <strong>Save as Draft</strong></li>
                        <li>System validates and creates employee profile</li>
                    </ol>
                    <p><strong>What happens after:</strong></p>
                    <ul>
                        <li>Employee gets login credentials via email/SMS</li>
                        <li>Employee appears in department lists</li>
                        <li>HR can now configure salary and attendance</li>
                    </ul>

                    <h5 className="mt-4">B. Salary Configuration</h5>
                    <p><strong>Purpose:</strong> Set up salary structure for employees</p>
                    <p><strong>Steps:</strong></p>
                    <ol>
                        <li>Go to <strong>Payroll Management</strong> → <strong>Salary Configuration</strong></li>
                        <li>Select employee from list</li>
                        <li>Configure salary components:
                            <ul>
                                <li>Basic Salary</li>
                                <li>Allowances (HRA, DA, Travel, etc.)</li>
                                <li>Deductions (PF, ESI, TDS, etc.)</li>
                            </ul>
                        </li>
                        <li>Set effective date</li>
                        <li>Click <strong>Save</strong></li>
                    </ol>
                    <p><strong>Important Notes:</strong></p>
                    <ul>
                        <li>Salary must be configured before generating payroll</li>
                        <li>Changes take effect from the next payroll cycle</li>
                        <li>System auto-calculates deductions based on rules</li>
                    </ul>

                    <h5 className="mt-4">C. Attendance & Leave Configuration</h5>
                    <p><strong>Purpose:</strong> Set up attendance rules, holidays, and leave policies</p>

                    <p><strong>Steps for Holiday Calendar:</strong></p>
                    <ol>
                        <li>Navigate to <strong>Attendance & Leave Management</strong> → <strong>Holiday Calendar</strong></li>
                        <li>Select date on calendar</li>
                        <li>Enter holiday name and type (National/Local/Optional)</li>
                        <li>Click <strong>Add Holiday</strong></li>
                        <li>System notifies all employees</li>
                    </ol>

                    <p><strong>Steps for Leave Type Configuration:</strong></p>
                    <ol>
                        <li>Go to <strong>Leave Management</strong> → <strong>Leave Types</strong></li>
                        <li>Click <strong>Add Leave Type</strong></li>
                        <li>Configure:
                            <ul>
                                <li>Leave Name (Casual, Sick, Earned, etc.)</li>
                                <li>Annual Quota (e.g., 12 days)</li>
                                <li>Carry Forward Rules</li>
                                <li>Approval Hierarchy</li>
                                <li>Encashment Rules</li>
                                <li>Assign to departments/roles</li>
                            </ul>
                        </li>
                        <li>Click <strong>Save</strong></li>
                    </ol>

                    <p><strong>Steps for Shift Configuration:</strong></p>
                    <ol>
                        <li>Go to <strong>Shift Management</strong> → <strong>Create Shift</strong></li>
                        <li>Enter:
                            <ul>
                                <li>Shift Name (Day/Night/General)</li>
                                <li>Start Time and End Time</li>
                                <li>Grace Period</li>
                                <li>Half-day threshold</li>
                            </ul>
                        </li>
                        <li>Assign to locations/employees</li>
                        <li>Click <strong>Save</strong></li>
                    </ol>

                    <h5 className="mt-4">D. Generate Payroll</h5>
                    <p><strong>Purpose:</strong> Process monthly salary for all employees</p>
                    <p><strong>Steps:</strong></p>
                    <ol>
                        <li>Navigate to <strong>Payroll Management</strong> → <strong>Generate Payroll</strong></li>
                        <li>Select month and year</li>
                        <li>System automatically:
                            <ul>
                                <li>Fetches attendance data</li>
                                <li>Calculates working days</li>
                                <li>Applies leave deductions</li>
                                <li>Calculates taxes and statutory deductions</li>
                            </ul>
                        </li>
                        <li>Review payroll summary</li>
                        <li>Make manual adjustments if needed (bonuses, special deductions)</li>
                        <li>Click <strong>Approve Payroll</strong></li>
                        <li>System generates salary slips</li>
                        <li>Slips are emailed and available in employee portal</li>
                    </ol>
                    <p><strong>What to check before approval:</strong></p>
                    <ul>
                        <li>Attendance data is complete</li>
                        <li>No pending leave approvals</li>
                        <li>Salary configurations are updated</li>
                        <li>Special deductions/bonuses are added</li>
                    </ul>
                </>
            )
        },
        {
            id: 'director-panel',
            title: '👤 Director Panel',
            searchText: 'director panel create sr hr user system setup companies customers company mapping',
            content: (
                <>
                    <h3>2. DIRECTOR PANEL</h3>
                    <h4>What Director Can Do</h4>
                    <p>The Director has full system access and initiates the system setup.</p>

                    <h4 className="mt-4">Key Responsibilities</h4>

                    <h5 className="mt-3">A. Create Sr. HR User</h5>
                    <p><strong>Steps:</strong></p>
                    <ol>
                        <li>Login to Director Panel</li>
                        <li>Navigate to <strong>User Management</strong> → <strong>Create User</strong></li>
                        <li>Select Role: <strong>Sr. HR</strong></li>
                        <li>Enter user details and credentials</li>
                        <li>Click <strong>Create</strong></li>
                    </ol>

                    <h5 className="mt-4">B. System Setup (Essential First Steps)</h5>

                    <p><strong>1. Create Companies</strong></p>
                    <p><strong>Purpose:</strong> Set up your organization's companies in the system</p>
                    <p><strong>Steps:</strong></p>
                    <ol>
                        <li>Go to <strong>Company Management</strong> → <strong>Add Company</strong></li>
                        <li>Enter:
                            <ul>
                                <li>Company Name</li>
                                <li>Registration Details</li>
                                <li>GST Number</li>
                                <li>Address</li>
                                <li>Contact Information</li>
                            </ul>
                        </li>
                        <li>Click <strong>Save</strong></li>
                    </ol>

                    <p><strong>2. Create Customers</strong></p>
                    <p><strong>Purpose:</strong> Add clients who will purchase your services</p>
                    <p><strong>Steps:</strong></p>
                    <ol>
                        <li>Navigate to <strong>Customer Management</strong> → <strong>Add Customer</strong></li>
                        <li>Fill in:
                            <ul>
                                <li>Customer Name</li>
                                <li>Contact Person</li>
                                <li>Email and Phone</li>
                                <li>Billing Address</li>
                                <li>GST Number (if applicable)</li>
                            </ul>
                        </li>
                        <li>Click <strong>Save</strong></li>
                    </ol>

                    <p><strong>3. Create Customer Company Mapping</strong></p>
                    <p><strong>Purpose:</strong> Link customers to specific company entities</p>
                    <p><strong>Steps:</strong></p>
                    <ol>
                        <li>Go to <strong>Customer Management</strong> → <strong>Customer Company</strong></li>
                        <li>Select Customer from dropdown</li>
                        <li>Select Company</li>
                        <li>Define contract terms</li>
                        <li>Click <strong>Save</strong></li>
                    </ol>
                </>
            )
        },
        {
            id: 'sr-hr-panel',
            title: '👥 Sr. HR Panel',
            searchText: 'sr hr panel create department accounts scm accounts hrm',
            content: (
                <>
                    <h3>3. SR. HR PANEL</h3>
                    <h4>What Sr. HR Can Do</h4>
                    <p>Sr. HR creates department accounts and manages high-level HR operations.</p>

                    <h4 className="mt-4">Key Responsibilities</h4>

                    <h5 className="mt-3">Create Department Accounts</h5>
                    <p><strong>Purpose:</strong> Set up user accounts for all departments</p>
                    <p><strong>Steps:</strong></p>
                    <ol>
                        <li>Login to Sr. HR Panel</li>
                        <li>Navigate to <strong>User Management</strong> → <strong>Create Department User</strong></li>
                        <li>Select Department:
                            <ul>
                                <li>SCM (Supply Chain Management)</li>
                                <li>Accounts</li>
                                <li>HRM (Human Resource Management)</li>
                            </ul>
                        </li>
                        <li>Fill in user details:
                            <ul>
                                <li>Name and Email</li>
                                <li>Contact Number</li>
                                <li>Designation (HOD/Manager/Executive)</li>
                            </ul>
                        </li>
                        <li>Assign permissions</li>
                        <li>Click <strong>Create</strong></li>
                    </ol>
                    <p><strong>Departments to create:</strong></p>
                    <ul>
                        <li><strong>SCM Department</strong> - For procurement, inventory, and site budgets</li>
                        <li><strong>Accounts Department</strong> - For invoicing, payments, and financial tracking</li>
                        <li><strong>HRM Department</strong> - For attendance, leave, and payroll</li>
                    </ul>
                </>
            )
        },
        {
            id: 'scm-department',
            title: '📦 SCM Dept',
            searchText: 'scm department supply chain site management create site budget vendor purchase request po inventory grn stock out transfer payment ticket',
            content: (
                <>
                    <h3>4. SCM DEPARTMENT (SUPPLY CHAIN MANAGEMENT)</h3>
                    <h4>What SCM Can Do</h4>
                    <p>SCM manages sites, vendors, procurement, inventory, and payments.</p>

                    <h4 className="mt-4">A. Site Management</h4>

                    <h5 className="mt-3">1. Create Site</h5>
                    <p><strong>Purpose:</strong> Add new solar installation or O&M site</p>
                    <p><strong>Steps:</strong></p>
                    <ol>
                        <li>Login to SCM Panel</li>
                        <li>Navigate to <strong>Sites</strong> → <strong>Create Site</strong></li>
                        <li>Fill in Basic Details:
                            <ul>
                                <li>Site Name</li>
                                <li>Site Type (New Installation / O&M Contract)</li>
                                <li>Site Code</li>
                                <li>Company (select from dropdown)</li>
                                <li>Customer (select from dropdown)</li>
                            </ul>
                        </li>
                        <li>Fill in Location Details:
                            <ul>
                                <li>Address</li>
                                <li>City, State, PIN</li>
                                <li>GPS Coordinates (if available)</li>
                            </ul>
                        </li>
                        <li>Click <strong>Save</strong></li>
                    </ol>

                    <h5 className="mt-4">2. Create Site Budget</h5>
                    <p><strong>Purpose:</strong> Allocate budget for site expenses</p>
                    <p><strong>Steps:</strong></p>
                    <ol>
                        <li>Go to <strong>Sites</strong> → Select Site → <strong>Budget</strong></li>
                        <li>Add Expense Heads:
                            <ul>
                                <li>Click <strong>Add Expense Head</strong></li>
                                <li>Enter Head Name (e.g., Material, Labor, Transport)</li>
                                <li>Enter Budget Amount</li>
                                <li>Select applicable items</li>
                            </ul>
                        </li>
                        <li>Add Items under each head:
                            <ul>
                                <li>Item Name, Quantity, Unit Price, Total</li>
                            </ul>
                        </li>
                        <li>Add General Expense Head (for miscellaneous costs)</li>
                        <li>Review total budget</li>
                        <li>Click <strong>Save Budget</strong></li>
                    </ol>
                    <p><strong>Budget Components:</strong></p>
                    <ul>
                        <li>Expense Head: Major categories (Material, Labor, etc.)</li>
                        <li>Items: Specific products/services under each head</li>
                        <li>General Expense: Miscellaneous operational costs</li>
                    </ul>

                    <h4 className="mt-4">B. Vendor Management</h4>
                    <h5 className="mt-3">Vendor Onboarding</h5>
                    <p><strong>Purpose:</strong> Add vendors for procurement</p>
                    <p><strong>Steps:</strong></p>
                    <ol>
                        <li>Navigate to <strong>Supply Chain Configuration</strong> → <strong>Vendor List</strong></li>
                        <li>Click <strong>Add Vendor</strong></li>
                        <li>Fill in vendor details:
                            <ul>
                                <li>Vendor Name</li>
                                <li>Contact Person</li>
                                <li>Email and Phone</li>
                                <li>Address</li>
                                <li>GST Number</li>
                                <li>Bank Details</li>
                                <li>Service Type</li>
                            </ul>
                        </li>
                        <li>Upload documents (GST Certificate, PAN, etc.)</li>
                        <li>Click <strong>Save</strong></li>
                    </ol>
                    <p><strong>Managing Vendors:</strong></p>
                    <ul>
                        <li>Edit: Update vendor information</li>
                        <li>View: Check vendor transaction history</li>
                        <li>Deactivate: Disable vendor if no longer working</li>
                    </ul>

                    <h4 className="mt-4">C. Purchase Request & Purchase Order Flow</h4>

                    <h5 className="mt-3">1. Receive Purchase Request</h5>
                    <p><strong>Purpose:</strong> Site staff creates purchase requests, SCM reviews</p>
                    <p><strong>How it works:</strong></p>
                    <ul>
                        <li>Plant Head/Site Engineer creates purchase request</li>
                        <li>Request appears in SCM Panel under Purchase → Pending Requests</li>
                    </ul>

                    <h5 className="mt-4">2. Approve/Reject Purchase Request</h5>
                    <p><strong>Steps:</strong></p>
                    <ol>
                        <li>Go to <strong>Purchase</strong> → <strong>Purchase Requests</strong></li>
                        <li>View request details: Site name, Items requested, Quantities, Estimated cost, Justification</li>
                        <li>Check site budget availability</li>
                        <li>Click <strong>Approve</strong> or <strong>Reject</strong></li>
                        <li>If rejecting, add reason</li>
                    </ol>
                    <p><strong>What happens after approval:</strong> Request moves to "Approved" status. SCM can now create Purchase Order.</p>

                    <h5 className="mt-4">3. Create Purchase Order (PO)</h5>
                    <p><strong>Purpose:</strong> Create formal order to vendor</p>
                    <p><strong>Steps:</strong></p>
                    <ol>
                        <li>Go to <strong>Purchase</strong> → <strong>Approved Requests</strong></li>
                        <li>Select request</li>
                        <li>Click <strong>Create Purchase Order</strong></li>
                        <li>Fill in PO details:
                            <ul>
                                <li>Select Vendor</li>
                                <li>Confirm items and quantities</li>
                                <li>Add pricing</li>
                                <li>Payment terms (Advance/Partial/Full)</li>
                                <li>Delivery date</li>
                                <li>Add terms & conditions</li>
                            </ul>
                        </li>
                        <li>Click <strong>Create PO</strong></li>
                    </ol>
                    <p><strong>What happens next:</strong> PO is sent to Accounts Department for approval. Vendor is notified.</p>

                    <h5 className="mt-4">4. Short Close Purchase Order</h5>
                    <p><strong>Purpose:</strong> Close PO when goods are fully received</p>
                    <p><strong>Steps:</strong></p>
                    <ol>
                        <li>Go to <strong>Purchase</strong> → <strong>Active Purchase Orders</strong></li>
                        <li>Select PO</li>
                        <li>Verify all GRNs are completed</li>
                        <li>Click <strong>Short Close</strong></li>
                        <li>Add remarks if needed</li>
                        <li>Click <strong>Confirm</strong></li>
                    </ol>
                    <p><strong>When to short close:</strong> All items received via GRN, No further deliveries expected, Payment process initiated.</p>

                    <h4 className="mt-4">D. Inventory Management</h4>

                    <h5 className="mt-3">1. Create GRN (Goods Received Note)</h5>
                    <p><strong>Purpose:</strong> Record receipt of goods from vendor</p>
                    <p><strong>Steps:</strong></p>
                    <ol>
                        <li>Navigate to <strong>Inventory</strong> → <strong>Stock In (GRN)</strong></li>
                        <li>Select site</li>
                        <li>Select approved Purchase Order</li>
                        <li>System shows: PO items, Ordered quantity, Already received quantity, Pending quantity</li>
                        <li>Fill GRN details:
                            <ul>
                                <li>Select items being received</li>
                                <li>Enter received quantity</li>
                                <li>Upload photos of goods</li>
                                <li>Add description/condition notes</li>
                                <li>Enter GRN date</li>
                            </ul>
                        </li>
                        <li>Click <strong>Submit GRN</strong></li>
                    </ol>
                    <p><strong>What happens:</strong> Stock is added to site inventory. PO items marked as partially/fully received. Multiple GRNs can be created for same PO.</p>
                    <p><strong>Important:</strong> Cannot create GRN for unapproved PO. Received quantity cannot exceed ordered quantity. Photos are mandatory for verification.</p>

                    <h5 className="mt-4">2. Create Stock Out</h5>
                    <p><strong>Purpose:</strong> Remove items from site inventory</p>
                    <p><strong>Types of Stock Out:</strong> Consumption, Sale, Scrap</p>
                    <p><strong>Steps:</strong></p>
                    <ol>
                        <li>Go to <strong>Inventory</strong> → <strong>Stock Out</strong></li>
                        <li>Click <strong>Create Stock Out</strong></li>
                        <li>Select stock out type, Select site</li>
                        <li>Choose items from inventory</li>
                        <li>Enter: Quantity, Reason/Purpose, Upload supporting documents</li>
                        <li>Click <strong>Submit</strong></li>
                    </ol>
                    <p><strong>Approval Flow:</strong> Request goes to Senior Approver. Upon approval, stock is deducted. Status marked as "Completed".</p>

                    <h5 className="mt-4">3. Transfer Assets Between Sites</h5>
                    <p><strong>Purpose:</strong> Move inventory from one site to another</p>
                    <p><strong>Steps:</strong></p>
                    <ol>
                        <li>Navigate to <strong>Transfer Assets</strong></li>
                        <li>Select Source Site (from where stock moves)</li>
                        <li>Select Destination Site (where stock goes)</li>
                        <li>System shows available stock at source</li>
                        <li>Select items to transfer, Enter quantity</li>
                        <li>Add remarks/reason</li>
                        <li>Click <strong>Submit Transfer Request</strong></li>
                    </ol>
                    <p><strong>Approval Flow:</strong> Request sent for approval. Once approved: Stock deducted from source site, added to destination site. Transfer logged for audit.</p>

                    <h4 className="mt-4">E. Payment Ticket Management</h4>
                    <p><strong>Types of Payment Tickets:</strong></p>
                    <ul>
                        <li>Against PO: Payment for vendor against purchase order</li>
                        <li>General: Non-PO payments (rent, utilities, misc.)</li>
                        <li>Reimbursement: Employee expense reimbursement</li>
                        <li>Petty Cash: Internal staff operational expenses</li>
                    </ul>

                    <h5 className="mt-3">Create Payment Ticket - Against PO</h5>
                    <p><strong>Purpose:</strong> Request payment for vendor invoice</p>
                    <p><strong>Steps:</strong></p>
                    <ol>
                        <li>Go to <strong>Payment Ticket</strong> → <strong>Create Payment Ticket</strong></li>
                        <li>Select <strong>Against PO</strong></li>
                        <li>Select site, Select Purchase Order</li>
                        <li>Enter payment details: Invoice Number/Date, Amount, TDS, Payment type, Due date</li>
                        <li>Upload invoice copy, Add remarks</li>
                        <li>Click <strong>Submit</strong></li>
                    </ol>
                    <p><strong>What happens next:</strong> Ticket goes to Accounts for approval. After approval, Payment Advisory is created. Vendor payment is processed.</p>

                    <h5 className="mt-4">Create Payment Ticket - General</h5>
                    <p><strong>Purpose:</strong> Request payment for non-PO expenses</p>
                    <p><strong>Steps:</strong></p>
                    <ol>
                        <li>Go to <strong>Payment Ticket</strong> → <strong>Create Payment Ticket</strong></li>
                        <li>Select <strong>General</strong></li>
                        <li>Select site and vendor</li>
                        <li>Enter: Expense Head, Amount, Description, Due date</li>
                        <li>Upload supporting documents</li>
                        <li>Click <strong>Submit</strong></li>
                    </ol>

                    <h5 className="mt-4">Create Payment Ticket - Reimbursement</h5>
                    <p><strong>Purpose:</strong> Reimburse employee expenses</p>
                    <p><strong>Steps:</strong> Select Reimbursement, Select employee, Enter expense details, Upload bills/receipts, Click <strong>Submit</strong>.</p>

                    <h5 className="mt-4">Create Payment Ticket - Petty Cash</h5>
                    <p><strong>Purpose:</strong> Issue petty cash to staff for operational expenses</p>
                    <p><strong>Steps:</strong> Select Petty Cash, Select staff member, Enter Amount/Purpose/Department/Site, Click <strong>Submit</strong>.</p>
                    <p><strong>Staff Responsibility:</strong> Staff must log expense details in their portal, upload receipts, and justify the amount used.</p>

                    <h4 className="mt-4">F. Supply Chain Configuration</h4>

                    <h5 className="mt-3">1. Expense Head Management</h5>
                    <p><strong>Purpose:</strong> Define expense categories for budgeting</p>
                    <p><strong>Steps:</strong> Navigate to Supply Chain Configuration → Expense Head → Click Add Expense Head → Enter head name → Click Save.</p>

                    <h5 className="mt-3">2. General Expense Head</h5>
                    <p><strong>Purpose:</strong> For miscellaneous expenses not in main categories</p>
                    <p><strong>Steps:</strong> Go to General Expense Head → Click Add → Enter name → Click Save.</p>

                    <h5 className="mt-3">3. Service Type</h5>
                    <p><strong>Purpose:</strong> Categorize vendor services</p>
                    <p><strong>Steps:</strong> Navigate to Service Type → Click Add Service Type → Enter type → Click Save.</p>

                    <h5 className="mt-3">4. Item Master</h5>
                    <p><strong>Purpose:</strong> Create catalog of items for procurement</p>
                    <p><strong>Steps:</strong> Go to Item Master → Click Add Item → Fill in Item Name, Code, Expense Head, Unit of Measurement, HSN Code, Description → Click Save.</p>

                    <h4 className="mt-4">G. HRM Functions in SCM Panel</h4>
                    <p>SCM staff also need to manage their own attendance and leave.</p>
                    <ul>
                        <li><strong>Mark Daily Attendance:</strong> Login to SCM Portal → Dashboard shows Mark Attendance button → Click button.</li>
                        <li><strong>Apply for Leave:</strong> Navigate to HRM → Leave Request → Apply Leave. Select Leave Type, Dates, Reason → Click Submit.</li>
                        <li><strong>Apply for AR (Attendance Regularization):</strong> Go to HRM → AR Request → Apply AR → Select date, Provide reason, Upload proof → Submit.</li>
                        <li><strong>Apply for OD (On Duty):</strong> Navigate to OD Request → Apply OD → Select date/duration, Enter location/purpose → Submit.</li>
                    </ul>
                </>
            )
        },
        {
            id: 'accounts-department',
            title: '💰 Accounts Dept',
            searchText: 'accounts department work order invoice transaction debit note po approval payment ticket advisory salary ticket audit ledgers',
            content: (
                <>
                    <h3>5. ACCOUNTS DEPARTMENT</h3>
                    <h4>What Accounts Can Do</h4>
                    <p>Accounts manages all financial operations including invoices, payments, ledgers, and PO approvals.</p>

                    <h4 className="mt-4">A. Work Order Management</h4>
                    <h5 className="mt-3">Create Work Order</h5>
                    <p><strong>Purpose:</strong> Generate work order for site activities (invoicing basis)</p>
                    <p><strong>Steps:</strong></p>
                    <ol>
                        <li>Login to Accounts Panel</li>
                        <li>Navigate to <strong>Work Order</strong> → <strong>Add Work Order</strong></li>
                        <li>Fill in details: Select Company, Select Site, Work Order Number, Work Order Date, Scope of Work, Contract Value, Duration</li>
                        <li>Click <strong>Save</strong></li>
                    </ol>
                    <p><strong>Purpose of Work Order:</strong> Basis for creating invoices, Tracks project/maintenance contract scope, Links customer agreements to financial transactions.</p>

                    <h4 className="mt-4">B. Invoice Management</h4>

                    <h5 className="mt-3">1. Create Invoice</h5>
                    <p><strong>Purpose:</strong> Bill customer for work completed</p>
                    <p><strong>Steps:</strong></p>
                    <ol>
                        <li>Go to <strong>Invoice</strong> → <strong>Create Invoice</strong></li>
                        <li>Select site, Select Work Order</li>
                        <li>Fill invoice details: Invoice Number/Date, Billing Period, Line items (Services/Materials), GST details, TDS (if applicable)</li>
                        <li>Click <strong>Create Invoice</strong></li>
                    </ol>
                    <p><strong>What happens:</strong> Invoice appears in Customer Ledger, System tracks payment due date, TDS Receivable is updated.</p>

                    <h5 className="mt-4">2. Create Transaction (Against Invoice)</h5>
                    <p><strong>Purpose:</strong> Record payment received from customer</p>
                    <p><strong>Steps:</strong></p>
                    <ol>
                        <li>Navigate to <strong>Invoice</strong> → <strong>View Invoice</strong></li>
                        <li>Click <strong>Create Transaction</strong></li>
                        <li>Enter: Transaction Date, Amount Received, Payment Mode (Bank Transfer/Cheque/Cash), Transaction Reference</li>
                        <li>Click <strong>Save</strong></li>
                    </ol>
                    <p><strong>What happens:</strong> Invoice amount is reduced, Customer Ledger updated, Cash Book updated automatically.</p>

                    <h5 className="mt-4">3. Create Debit Note</h5>
                    <p><strong>Purpose:</strong> Adjust invoice for additional charges or corrections</p>
                    <p><strong>Steps:</strong> Go to Invoice → Select Invoice → Click Add Debit Note → Enter Number/Date, Reason, Amount → Click Save.</p>

                    <h4 className="mt-4">C. Purchase Order Approval</h4>
                    <h5 className="mt-3">Approve/Reject PO Created by SCM</h5>
                    <p><strong>Purpose:</strong> Review and approve purchase orders for budget compliance</p>
                    <p><strong>Steps:</strong></p>
                    <ol>
                        <li>Navigate to <strong>Purchase Order</strong> → <strong>Pending Approval</strong></li>
                        <li>Select PO</li>
                        <li>Review: Site/vendor details, Items/quantities, Total amount, Available site budget</li>
                        <li>Check if PO exceeds budget:
                            <ul>
                                <li>If within budget: Click <strong>Approve</strong></li>
                                <li>If exceeds budget:
                                    <ul>
                                        <li>Option 1: Click <strong>Reject</strong> with reason</li>
                                        <li>Option 2: Click <strong>Request Budget Increase</strong> → Send to Admin</li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                    </ol>
                    <p><strong>What happens after approval:</strong> PO is finalized, Vendor can be notified, SCM can proceed with procurement.</p>

                    <h4 className="mt-4">D. Payment Ticket Management</h4>

                    <h5 className="mt-3">1. Create Payment Ticket</h5>
                    <p><strong>Purpose:</strong> Accounts can also create payment tickets</p>
                    <p><strong>Steps:</strong> Go to Payment Ticket → Create Payment Ticket → Select type (Against PO/General) → Follow same steps as SCM department → Click Submit.</p>

                    <h5 className="mt-4">2. Approve Payment Tickets</h5>
                    <p><strong>Purpose:</strong> Review and approve payment requests from other departments</p>
                    <p><strong>Steps:</strong></p>
                    <ol>
                        <li>Navigate to <strong>Payment Ticket</strong> → <strong>Pending Approval</strong></li>
                        <li>Review ticket details: Vendor information, Invoice details, Supporting documents, Budget availability</li>
                        <li>Verify invoice authenticity</li>
                        <li>Click <strong>Approve</strong> or <strong>Reject</strong></li>
                    </ol>
                    <p>If approved, next step: Create Payment Advisory.</p>

                    <h5 className="mt-4">3. Create Payment Advisory</h5>
                    <p><strong>Purpose:</strong> Final authorization for payment processing</p>
                    <p><strong>Steps:</strong> Go to Payment Advisory → Select approved payment tickets → Group by vendor or due date → Enter Payment date/mode/bank details → Click <strong>Create Advisory</strong>.</p>
                    <p><strong>What happens:</strong> Payment team processes payment, Vendor Ledger updated, Cash Book updated.</p>

                    <h4 className="mt-4">E. Salary Ticket Approval</h4>
                    <p><strong>Purpose:</strong> Final approval of monthly payroll</p>
                    <p><strong>Steps:</strong> Navigate to Salary Ticket → Pending Approval → Review Employee list, Salary breakup, Total payout, Deductions → Verify calculations → Click <strong>Approve</strong> or <strong>Reject</strong>.</p>
                    <p>If approved: Salaries are processed for disbursement, Payroll reports generated.</p>

                    <h4 className="mt-4">F. Financial Tracking & Ledgers</h4>

                    <h5 className="mt-3">1. TDS Ledger</h5>
                    <p><strong>Purpose:</strong> Track Tax Deducted at Source (receivable and payable)</p>
                    <p><strong>How to use:</strong> Navigate to TDS Ledger. View two sections: TDS Receivable (deducted by customers) and TDS Payable (to be deducted for vendors). Apply filters like Company, Site, Fin Year. Export report if needed.</p>

                    <h5 className="mt-4">2. Customer Ledger</h5>
                    <p><strong>Purpose:</strong> Track all financial transactions with customers</p>
                    <p><strong>Steps:</strong> Go to Customer Ledger → Select company and site → View Total invoices raised, Payments received, Outstanding amount, TDS deducted. Use cases: Check customer payment status, Follow up on overdue payments.</p>

                    <h5 className="mt-4">3. Vendor Ledger</h5>
                    <p><strong>Purpose:</strong> Track payments to vendors</p>
                    <p><strong>Steps:</strong> Navigate to Vendor Ledger → Select vendor → View Total payment tickets raised, Amount paid, Pending payments, TDS deducted.</p>

                    <h5 className="mt-4">4. Cash Book</h5>
                    <p><strong>Purpose:</strong> Track all cash and bank transactions</p>
                    <p><strong>What it shows:</strong> Date-wise transaction log, Income (Customer payments), Expenses (Vendor payments, salaries), Opening/closing balance.</p>
                    <p><strong>Steps:</strong> Go to Cash Book → Select date range → Apply company/site filter → View transaction summary → Export for reconciliation.</p>

                    <h4 className="mt-4">G. HRM Functions in Accounts Panel</h4>
                    <p>Accounts staff also manage their own attendance and leave like SCM. Follow the same steps as mentioned in SCM → HRM Functions: Mark Daily Attendance, Apply for Leave, Apply for AR, Apply for OD, Download Salary Slips.</p>
                </>
            )
        },
        {
            id: 'hrm-department',
            title: '👔 HRM Dept',
            searchText: 'hrm department shift time salary head leave settings site salary employee onboarding mark attendance approve leaves ar od holiday location',
            content: (
                <>
                    <h3>6. HRM DEPARTMENT</h3>
                    <h4>What HRM Can Do</h4>
                    <p>HRM manages employee attendance, leave, salary configuration, and payroll operations.</p>

                    <h4 className="mt-4">A. Shift and Time Configuration</h4>

                    <h5 className="mt-3">1. Create Shift Timing</h5>
                    <p><strong>Purpose:</strong> Define work shifts for different employee groups</p>
                    <p><strong>Steps:</strong> Login to HRM Panel → Navigate to HRM Configuration → Shift and Time Management → Click Add Shift → Enter Shift Name/Start Time/End Time/Grace Period/Half-day threshold/Full-day threshold → Click Save.</p>
                    <p><strong>Assigning Shift:</strong> Go to Employee Management → Select employee → Assign shift from dropdown → Click Update.</p>

                    <h5 className="mt-4">2. Office Time Management</h5>
                    <p><strong>Purpose:</strong> Set general office hours</p>
                    <p><strong>Steps:</strong> Navigate to Office Management → Enter Office Start Time, Office End Time, Working Days, Weekly Off → Click Save.</p>

                    <h4 className="mt-4">B. Salary Head Configuration</h4>
                    <p><strong>Purpose:</strong> Define salary components (earnings and deductions)</p>
                    <p><strong>Steps:</strong> Go to HRM Configuration → Salary Head → Click Add Salary Head → Fill in Head Name, Type (Earning/Deduction), Calculation Method (Fixed/Percentage), Is Taxable? → Click Save.</p>

                    <h4 className="mt-4">C. Leave Settings</h4>
                    <p><strong>Purpose:</strong> Define leave policies for organization</p>
                    <p><strong>Steps:</strong> Navigate to Leave Setting → Click Add Leave Type → Configure: Leave Name, Annual Quota, Max continuous days, Min gap, Carry forward rules, Encashment rules, Document required?, Approval hierarchy → Click Save.</p>

                    <h4 className="mt-4">D. Site Salary Head</h4>
                    <p><strong>Purpose:</strong> Different sites may have different salary components</p>
                    <p><strong>Steps:</strong> Navigate to Site Salary Head → Select site → Click Add Salary Component → Choose from master salary heads → Modify amounts if needed → Click Save.</p>

                    <h4 className="mt-4">E. Employee Onboarding</h4>
                    <p><strong>Purpose:</strong> Add employee to system (same as Admin onboarding)</p>
                    <p><strong>Steps:</strong> Go to Employee Onboarding → Click Add New Employee → Fill all sections (Personal, Contact, Dept, Reporting Manager, Bank, etc.) → Assign Office/Site, Shift, Approver → Configure Employee Type/Probation → Click Save.</p>
                    <p><strong>System actions:</strong> Creates login credentials, Sends welcome email, Employee can now mark attendance.</p>

                    <h4 className="mt-4">F. Mark Attendance</h4>
                    <p><strong>Purpose:</strong> HRM can mark attendance on behalf of employees</p>
                    <p><strong>Steps:</strong> Navigate to Attendance Management → Select date → View employee list → For each employee: Mark Present/Absent/Half-day/On Leave, If late enter time, Add remarks → Click Save Attendance. <strong>Bulk Attendance:</strong> Click Mark All Present → Unmark absent employees → Click Save.</p>

                    <h4 className="mt-4">G. Approve Attendance, Leave, AR, and OD</h4>
                    <h5 className="mt-3">1. Approve/Reject Leave Requests</h5>
                    <p><strong>Steps:</strong> Go to Leave Management → Pending Approvals → View leave requests → Click Approve or Reject → Add remarks if rejecting → Click Confirm.</p>

                    <h5 className="mt-4">2. Approve/Reject AR Requests</h5>
                    <p><strong>Purpose:</strong> Regularize attendance for missed/wrong punch</p>
                    <p><strong>Steps:</strong> Navigate to AR Requests → Pending → Review request details → Verify reason and proof → Click Approve or Reject.</p>

                    <h5 className="mt-4">3. Approve/Reject OD Requests</h5>
                    <p><strong>Purpose:</strong> Approve on-duty requests</p>
                    <p><strong>Steps:</strong> Go to OD Requests → Pending → Review OD details → Click Approve or Reject. If approved: Day marked as present, OD status shown.</p>

                    <h4 className="mt-4">H. Payment Tickets</h4>
                    <p><strong>Purpose:</strong> Request payments for HR-related expenses (Recruitment, Training, Reimbursements).</p>
                    <p><strong>Steps:</strong> Navigate to Payment Ticket → Create → Select type → Fill details and submit.</p>

                    <h4 className="mt-4">I. Salary Tickets</h4>
                    <p><strong>Purpose:</strong> Process monthly payroll</p>
                    <p><strong>Steps:</strong> Go to Salary Tickets → Generate Payroll → Select month and year → System auto-calculates attendance/leave/overtime → Review payroll summary → Make manual adjustments → Click Submit to Accounts.</p>

                    <h4 className="mt-4">J. Holiday Settings</h4>
                    <p><strong>Purpose:</strong> Define company holidays</p>
                    <p><strong>Steps:</strong> Navigate to Holiday Setting → View calendar → Click Add Holiday → Enter Date, Name, Type → Click Save.</p>

                    <h4 className="mt-4">K. Office Location</h4>
                    <p><strong>Purpose:</strong> Set up locations for geo-fenced attendance</p>
                    <p><strong>Steps:</strong> Go to Office Location → Click Add Location → Enter Location Name, Address, GPS Coordinates, Geo-fence Radius → Assign to employees → Click Save.</p>

                    <h4 className="mt-4">L. HRM Self-Service Functions</h4>
                    <p>HRM staff also manage their own attendance: Mark Daily Attendance, Apply for Leave/AR/OD, Download Salary Slips (Follow same steps as SCM).</p>
                </>
            )
        },
        {
            id: 'operations-head',
            title: '⚡ Ops & Zonal Head',
            searchText: 'hod technical solar wind gss tl zonal head multi site management dashboard purchase request payment ticket finance reports',
            content: (
                <>
                    <h3>7. HOD - SOLAR/WIND/GSS/TL & ZONAL HEAD</h3>
                    <h4>What They Can Do</h4>
                    <p>Technical operations heads managing multiple sites.</p>

                    <h4 className="mt-4">Key Responsibilities</h4>

                    <h5 className="mt-3">A. Multi-Site Management Dashboard</h5>
                    <p><strong>Purpose:</strong> Oversee all assigned sites</p>
                    <p><strong>What you can see:</strong> Login to panel → Dashboard shows: All assigned sites, Site-wise project status, Ongoing purchase requests, Pending payment tickets, Site budgets and utilization, Team performance.</p>

                    <h5 className="mt-4">B. Approve/Reject Purchase Requests</h5>
                    <p><strong>Steps:</strong> Navigate to Purchase Requests → Pending → Filter by site → Review details → Click Approve or Reject.</p>

                    <h5 className="mt-4">C. Approve/Reject Payment Tickets</h5>
                    <p><strong>Steps:</strong> Go to Payment Tickets → Pending Approval → Filter by assigned sites → Review payment details → Click Approve or Reject.</p>

                    <h5 className="mt-4">D. Create Purchase Request</h5>
                    <p><strong>Purpose:</strong> Can also initiate purchase requests</p>
                    <p><strong>Steps:</strong> Navigate to Purchase → Create Request → Select site → Add items/quantities → Enter justification → Click Submit.</p>

                    <h5 className="mt-4">E. Create Payment Ticket</h5>
                    <p><strong>Purpose:</strong> Request payments for site expenses</p>
                    <p><strong>Steps:</strong> Go to Payment Ticket → Create → Select type and site → Fill details → Click Submit.</p>

                    <h5 className="mt-4">F. View Finance-Approved POs</h5>
                    <p><strong>Purpose:</strong> Monitor approved purchase orders</p>
                    <p><strong>Steps:</strong> Navigate to Purchase Orders → Approved → View PO details → Can create payment ticket against PO.</p>

                    <h5 className="mt-4">G. Site-wise Reports</h5>
                    <p><strong>Purpose:</strong> Generate site performance reports (Budget utilization, Purchase request summary, Payment status, Team performance).</p>
                </>
            )
        },
        {
            id: 'plant-head',
            title: '🏭 Plant Head',
            searchText: 'plant head site management attendance approval leave ar od purchase request payment ticket',
            content: (
                <>
                    <h3>8. PLANT HEAD</h3>
                    <h4>What Plant Head Can Do</h4>
                    <p>Manages single or multiple sites within a state.</p>

                    <h4 className="mt-4">Key Responsibilities</h4>

                    <h5 className="mt-3">A. Attendance Management</h5>
                    <ul>
                        <li><strong>Mark Daily Attendance:</strong> Login to Plant Head Panel → Click Mark Attendance.</li>
                        <li><strong>Approve Team Attendance:</strong> Navigate to Attendance Management → Pending Approvals → View records → Approve/Reject.</li>
                        <li><strong>Approve Leave Requests:</strong> Go to Leave Management → Pending → Review team leave → Check balance → Approve/Reject.</li>
                        <li><strong>Approve AR (Attendance Regularization):</strong> Navigate to AR Requests → Pending → Review → Approve/Reject.</li>
                        <li><strong>Approve OD (On Duty):</strong> Go to OD Requests → Pending → Review → Approve/Reject.</li>
                    </ul>

                    <h5 className="mt-4">B. Site Purchase and Payment Management</h5>
                    <ul>
                        <li><strong>Manage Purchase Requests:</strong> Navigate to Purchase Requests → View pending requests from site team → Review details/budget → Approve/Reject.</li>
                        <li><strong>Create Payment Ticket:</strong> Go to Payment Ticket → Create → Select Against PO → Select finance-approved PO → Fill invoice details → Click Submit.</li>
                    </ul>

                    <h5 className="mt-4">C. Site-wise Reports</h5>
                    <p><strong>Purpose:</strong> Monitor site performance (Attendance, Leave, Purchase requests, Payment ticket status, Budget utilization).</p>
                </>
            )
        },
        {
            id: 'site-staff',
            title: '👷 Site Staff',
            searchText: 'site engineer technician mark attendance apply leave ar od salary slip mobile app',
            content: (
                <>
                    <h3>9. SITE ENGINEER & TECHNICIAN</h3>
                    <h4>What They Can Do</h4>
                    <p>On-site staff managing daily operations and attendance.</p>

                    <h4 className="mt-4">Key Responsibilities</h4>

                    <h5 className="mt-3">A. Mark Attendance</h5>
                    <p><strong>Steps:</strong> Open Employee Mobile App or Portal → Click Mark Attendance → App captures GPS location → Attendance recorded if within geo-fence.</p>
                    <p><strong>Important:</strong> Must be within office/site location radius. Late arrivals flagged.</p>

                    <h5 className="mt-4">B. Apply for Leave</h5>
                    <p><strong>Steps:</strong> Navigate to Leave → Apply Leave → Select leave type, Dates, Reason → Upload certificate (if sick) → Click Submit.</p>
                    <p><strong>Check Leave Status:</strong> Go to Leave → My Leaves → View status.</p>

                    <h5 className="mt-4">C. Apply for AR (Attendance Regularization)</h5>
                    <p><strong>Purpose:</strong> Fix missed or incorrect attendance</p>
                    <p><strong>Steps:</strong> Go to Attendance → Apply AR → Select date → Provide reason → Upload proof → Click Submit.</p>

                    <h5 className="mt-4">D. Apply for OD (On Duty)</h5>
                    <p><strong>Purpose:</strong> Mark attendance when working outside office</p>
                    <p><strong>Steps:</strong> Go to Attendance → Apply OD → Select date/time → Enter location/purpose → Click Submit.</p>

                    <h5 className="mt-4">E. View Attendance Summary</h5>
                    <p><strong>Purpose:</strong> Check monthly attendance record</p>
                    <p><strong>Steps:</strong> Navigate to Attendance → Summary → Select month → View Present/Absent/Half days/Leave days → Download Report.</p>

                    <h5 className="mt-4">F. Download Salary Slip</h5>
                    <p><strong>Steps:</strong> Login to Employee Portal → Navigate to Salary → Salary Slips → Select month → Click Download.</p>
                </>
            )
        },
        {
            id: 'payment-team',
            title: '💳 Payment Team',
            searchText: 'payment team accounts payment overview advisory bulk processing reject payment',
            content: (
                <>
                    <h3>10. PAYMENT TEAM (Accounts)</h3>
                    <h4>What Payment Team Can Do</h4>
                    <p>Process final payments to vendors after approval.</p>

                    <h4 className="mt-4">Key Responsibilities</h4>

                    <h5 className="mt-3">A. View Payment Overview</h5>
                    <p><strong>Purpose:</strong> See all approved payments requiring action</p>
                    <p><strong>Steps:</strong> Login to Accounts Panel → Navigate to Payment Overview → System displays all approved payment requests sorted by due date.</p>

                    <h5 className="mt-4">B. Create Payment Advisory</h5>
                    <p><strong>Purpose:</strong> Process vendor payments</p>
                    <p><strong>Steps:</strong> Select payment request → Click Create Payment Advisory → Verify details (Bank, Amount, TDS) → Enter Payment date/mode/Reference → Click Process Payment.</p>
                    <p><strong>What happens:</strong> Vendor Ledger updated, Cash Book updated, Status changed to "Paid".</p>

                    <h5 className="mt-4">C. Reject Payment</h5>
                    <p><strong>Purpose:</strong> Send back payment if issue found</p>
                    <p><strong>Steps:</strong> Select payment request → Click Reject → Provide reason → Click Confirm.</p>

                    <h5 className="mt-4">D. Bulk Payment Processing</h5>
                    <p><strong>Purpose:</strong> Process multiple payments together</p>
                    <p><strong>Steps:</strong> Filter payments → Select multiple → Click Bulk Process → Verify total → Create single payment advisory → Click Confirm.</p>
                </>
            )
        },
        {
            id: 'workflows',
            title: '🔄 Workflows',
            searchText: 'key process workflows employee onboarding payroll purchase request order invoice leave application stock transfer',
            content: (
                <>
                    <h3>KEY PROCESS WORKFLOWS</h3>

                    <div className="card card-body bg-light mb-3">
                        <h5 className="text-primary">Workflow 1: Employee Onboarding to Payroll</h5>
                        <p className="mb-0">Admin/HR creates employee profile → Configure salary structure → Assign shift and location → Employee starts marking attendance → HR monitors attendance and leave → End of month: Generate payroll → Accounts approves payroll → Salary disbursed → Employee receives salary slip.</p>
                    </div>

                    <div className="card card-body bg-light mb-3">
                        <h5 className="text-primary">Workflow 2: Purchase Request to Payment</h5>
                        <p className="mb-0">Site Engineer creates Purchase Request → Plant Head approves → Zonal Head/HOD approves → SCM receives and reviews → SCM creates Purchase Order → Accounts approves PO → Vendor delivers goods → Plant Head creates GRN → Stock added to inventory → SCM creates Payment Ticket (Against PO) → Accounts approves Payment Ticket → Accounts creates Payment Advisory → Payment Team processes payment → Vendor receives payment.</p>
                    </div>

                    <div className="card card-body bg-light mb-3">
                        <h5 className="text-primary">Workflow 3: Customer Invoice to Payment Receipt</h5>
                        <p className="mb-0">Accounts creates Work Order → Work completed at site → Accounts creates Invoice against Work Order → Invoice sent to customer → Customer makes payment → Accounts creates Transaction (against Invoice) → Customer Ledger updated → Cash Book updated → Invoice marked as paid.</p>
                    </div>

                    <div className="card card-body bg-light mb-3">
                        <h5 className="text-primary">Workflow 4: Leave Application Process</h5>
                        <p className="mb-0">Employee applies for leave → Immediate supervisor (Plant Head/Manager) reviews → Approves or Rejects → If Approved: HR receives notification → HR marks attendance as "On Leave" → Leave balance deducted → At month end: Leave affects salary calculation → Employee receives salary slip with leave deduction.</p>
                    </div>

                    <div className="card card-body bg-light mb-3">
                        <h5 className="text-primary">Workflow 5: Stock Transfer Between Sites</h5>
                        <p className="mb-0">SCM/Plant Head initiates transfer request → Selects source and destination site → Selects items and quantities → Request submitted for approval (if required) → Senior approver reviews → If Approved: Stock deducted from source, Stock added to destination, Transfer logged → Both sites can see updated inventory.</p>
                    </div>
                </>
            )
        },
        {
            id: 'mobile-app',
            title: '📱 Mobile App',
            searchText: 'mobile app guide download login daily attendance leave management profile salary tips',
            content: (
                <>
                    <h3>MOBILE APP GUIDE</h3>
                    <p>For Employees (Site Staff & Office Staff).</p>

                    <h4 className="mt-4">Download and Login</h4>
                    <ul>
                        <li>Download app from Play Store/App Store</li>
                        <li>Enter employee ID and password</li>
                        <li>Click Login</li>
                    </ul>

                    <h4 className="mt-4">Daily Attendance</h4>
                    <ul>
                        <li><strong>Mark Attendance:</strong> Open app, Click Mark Attendance, Allow location access, System verifies radius, Attendance marked.</li>
                        <li><strong>View Attendance History:</strong> Go to Attendance tab, Select month to view record.</li>
                    </ul>

                    <h4 className="mt-4">Leave Management</h4>
                    <ul>
                        <li><strong>Apply Leave:</strong> Go to Leave tab, Click Apply Leave, Select type/dates, Enter reason, Upload documents, Submit.</li>
                        <li><strong>Check Leave Balance:</strong> Leave → Leave Balance.</li>
                        <li><strong>Track Status:</strong> Leave → My Applications.</li>
                    </ul>

                    <h4 className="mt-4">Profile and Salary</h4>
                    <ul>
                        <li><strong>View Profile:</strong> Go to Profile tab to view info.</li>
                        <li><strong>Download Salary Slip:</strong> Go to Salary tab, Select month, Click Download.</li>
                    </ul>
                </>
            )
        },
        {
            id: 'tips-for-effective-use',
            title: '💡 Effective Use Tips',
            searchText: 'tips for effective use daily login document everything regular monitoring timely actions data accuracy team oversight budget management payment monitoring reporting reconciliation tds compliance customer follow up vendor relations',
            content: (
                <>
                    <h3>TIPS FOR EFFECTIVE USE</h3>

                    <h4 className="mt-4">For All Users</h4>
                    <ul>
                        <li><strong>Daily Login:</strong> Mark attendance at the start of day. Check pending approvals regularly.</li>
                        <li><strong>Document Everything:</strong> Always upload supporting documents. Add detailed remarks for approvals/rejections.</li>
                        <li><strong>Regular Monitoring:</strong> Check dashboards daily. Review pending tasks.</li>
                        <li><strong>Timely Actions:</strong> Approve/reject requests within 24 hours. Process payments before due dates.</li>
                        <li><strong>Data Accuracy:</strong> Double-check entries before submission. Verify vendor/customer details.</li>
                    </ul>

                    <h4 className="mt-4">For Managers and HODs</h4>
                    <ul>
                        <li><strong>Team Oversight:</strong> Monitor team attendance daily. Review leave balances monthly.</li>
                        <li><strong>Budget Management:</strong> Track site budgets weekly. Approve purchases within budget.</li>
                        <li><strong>Payment Monitoring:</strong> Process payment tickets on time. Verify invoice authenticity.</li>
                        <li><strong>Reporting:</strong> Generate and review reports monthly. Identify bottlenecks and resolve.</li>
                    </ul>

                    <h4 className="mt-4">For Accounts Team</h4>
                    <ul>
                        <li><strong>Reconciliation:</strong> Reconcile ledgers weekly. Match bank statements monthly.</li>
                        <li><strong>TDS Compliance:</strong> Track TDS deductions. File returns on time.</li>
                        <li><strong>Customer Follow-up:</strong> Monitor Customer Ledger. Follow up on overdue payments.</li>
                        <li><strong>Vendor Relations:</strong> Process payments on due dates. Maintain good vendor relationships.</li>
                    </ul>
                </>
            )
        },
        {
            id: 'troubleshooting',
            title: '🔧 Troubleshooting',
            searchText: 'troubleshooting common issues location not detected leave request not showing purchase order not creating payment ticket stuck salary slip not generated',
            content: (
                <>
                    <h3>TROUBLESHOOTING</h3>
                    <h4 className="mt-4">Common Issues and Solutions</h4>

                    <div className="accordion mt-3" id="troubleshootingAccordion">
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingOne">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                                    1. Cannot Mark Attendance: "Location not detected"
                                </button>
                            </h2>
                            <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#troubleshootingAccordion">
                                <div className="accordion-body">
                                    <strong>Solution:</strong>
                                    <ul>
                                        <li>Enable GPS on phone</li>
                                        <li>Check if within office geo-fence radius</li>
                                        <li>Check internet connection</li>
                                        <li>Contact HR if location settings need update</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingTwo">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                    2. Leave Request Not Showing
                                </button>
                            </h2>
                            <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#troubleshootingAccordion">
                                <div className="accordion-body">
                                    <strong>Issue:</strong> Applied leave not visible to approver<br />
                                    <strong>Solution:</strong>
                                    <ul>
                                        <li>Verify submission was successful</li>
                                        <li>Check if assigned to correct approver</li>
                                        <li>Contact HR to reassign approver</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingThree">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                    3. Purchase Order Not Creating
                                </button>
                            </h2>
                            <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#troubleshootingAccordion">
                                <div className="accordion-body">
                                    <strong>Issue:</strong> Cannot create PO from approved PR<br />
                                    <strong>Solution:</strong>
                                    <ul>
                                        <li>Verify PR is actually approved</li>
                                        <li>Check if budget is available</li>
                                        <li>Ensure vendor is active</li>
                                        <li>Contact Admin if issue persists</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingFour">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                    4. Payment Ticket Stuck
                                </button>
                            </h2>
                            <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#troubleshootingAccordion">
                                <div className="accordion-body">
                                    <strong>Issue:</strong> Payment not processing<br />
                                    <strong>Solution:</strong>
                                    <ul>
                                        <li>Check approval status</li>
                                        <li>Verify all documents uploaded</li>
                                        <li>Check if TDS details entered correctly</li>
                                        <li>Contact Accounts department</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingFive">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                    5. Salary Slip Not Generated
                                </button>
                            </h2>
                            <div id="collapseFive" className="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#troubleshootingAccordion">
                                <div className="accordion-body">
                                    <strong>Issue:</strong> Salary slip not available<br />
                                    <strong>Solution:</strong>
                                    <ul>
                                        <li>Check if payroll is approved</li>
                                        <li>Verify attendance was marked properly</li>
                                        <li>Contact HRM if issue persists</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )
        },
        {
            id: 'support-contact',
            title: '📞 Support',
            searchText: 'support contact technical issues email phone portal glossary terms ar od grn po pr tds',
            content: (
                <>
                    <h3>SUPPORT AND CONTACT</h3>
                    <p><strong>For technical issues or system support:</strong><br />
                        Email: <a href="mailto:support@shreenaths.com">support@shreenaths.com</a><br />
                    </p>
                    <p><strong>For department-specific queries:</strong><br />
                        HRM: <a href="mailto:compliances@shreenaths.com">compliances@shreenaths.com</a><br />
                        Accounts: <a href="mailto:accounts@shreenaths.com">accounts@shreenaths.com</a><br />
                        SCM: <a href="mailto:contracts@shreenaths.com">contracts@shreenaths.com</a>
                    </p>

                    <h4 className="mt-4">GLOSSARY</h4>
                    <ul className="list-unstyled">
                        <li><strong>AR - Attendance Regularization:</strong> Request to correct attendance record</li>
                        <li><strong>OD - On Duty:</strong> Working outside office but should be marked present</li>
                        <li><strong>GRN - Goods Received Note:</strong> Document confirming receipt of goods</li>
                        <li><strong>PO - Purchase Order:</strong> Formal order to vendor</li>
                        <li><strong>PR - Purchase Request:</strong> Internal request for procurement</li>
                        <li><strong>TDS - Tax Deducted at Source:</strong> Tax deducted from payments</li>
                        <li><strong>O&M - Operations & Maintenance:</strong> Ongoing service contracts</li>
                        <li><strong>HOD - Head of Department</strong></li>
                        <li><strong>SCM - Supply Chain Management</strong></li>
                        <li><strong>HRM - Human Resource Management</strong></li>
                    </ul>
                </>
            )
        }
    ];

    const filteredSections = sections.filter(section => {
        if (!searchTerm) return true;
        const lowerTerm = searchTerm.toLowerCase();

        return (
            section.title.toLowerCase().includes(lowerTerm) ||
            section.searchText.toLowerCase().includes(lowerTerm)
        );
    });

    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            const headerOffset = 180;
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
            setActiveSection(id);
        }
    };

    // Helper component for highlighting text helper
    const HighlightText = ({ children, highlight }) => {
        if (!highlight || !highlight.trim()) return children;

        const regex = new RegExp(`(${highlight.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');

        const process = (node) => {
            if (typeof node === 'string') {
                const parts = node.split(regex);
                if (parts.length === 1) return node;
                return parts.map((part, i) =>
                    regex.test(part) ? <mark key={i} className="bg-warning text-dark p-0 rounded-1">{part}</mark> : part
                );
            }

            if (React.isValidElement(node)) {
                if (node.props.children) {
                    return React.cloneElement(node, {
                        children: React.Children.map(node.props.children, process)
                    });
                }
                return node;
            }

            if (Array.isArray(node)) {
                return node.map(process);
            }

            return node;
        };

        return process(children);
    };

    useEffect(() => {
        const handleScroll = () => {
            const headerOffset = 220;
            const scrollPosition = window.scrollY + headerOffset;

            const current = sections.find(section => {
                const element = document.getElementById(section.id);
                if (element) {
                    const { offsetTop, offsetHeight } = element;
                    return scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight;
                }
                return false;
            });

            if (current && current.id !== activeSection) {
                setActiveSection(current.id);
            }
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll();

        return () => window.removeEventListener('scroll', handleScroll);
    }, [activeSection]);

    return (
        <>
            <div className="container-fluid how-to-use-container bg-light min-vh-100 p-0">
                {/* Top Navigation Bar */}
                <div className=" bg-white border-bottom shadow-sm how-to-use-top-nav">
                    <div className="container-fluid">
                        <div className="d-flex flex-wrap align-items-center justify-content-between py-2">
                            <div className="d-flex align-items-center mb-2 mb-lg-0">
                                <h5 className="mb-0 me-4 text-primary fw-medium">📖 User Guide</h5>
                                <div className="search-wrapper">
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        placeholder="🔍 Search topics..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        style={{ width: '250px' }}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Horizontal Scrollable Menu */}
                        <div className="nav-scroller py-1 mb-2">
                            <nav className="nav d-flex justify-content-start">
                                {filteredSections.map(section => (
                                    <button
                                        key={section.id}
                                        className={`p-2 text-decoration-none border-0 bg-transparent fw-medium ${activeSection === section.id ? 'text-primary border-bottom border-primary' : 'link-secondary'}`}
                                        onClick={() => scrollToSection(section.id)}
                                        style={{ whiteSpace: 'nowrap', marginRight: '15px', fontSize: '1rem' }}
                                    >
                                        {section.title}
                                    </button>
                                ))}
                            </nav>
                        </div>
                    </div>
                </div>

                {/* Main Content Area */}
                <div className="my-5">
                    <div className="text-center mb-4 mt-3">
                        <h2 className="fw-bold text-dark mb-2">Solar Panel ERP System</h2>
                        <p className="text-muted fs-5">Comprehensive Manual & Role-based Guides</p>
                    </div>
                    <div className="vstack gap-4">
                        {filteredSections.map(section => (
                            <div key={section.id} id={section.id} className="card border-0 shadow-sm p-4">
                                <HighlightText highlight={searchTerm}>
                                    {section.content}
                                </HighlightText>
                            </div>
                        ))}

                        {filteredSections.length === 0 && (
                            <div className="text-center py-5">
                                <h4 className="text-muted">No matching topics found for "{searchTerm}"</h4>
                            </div>
                        )}
                    </div>

                </div>
            </div>
        </>
    );
};

export default HowToUse;
